import { render, staticRenderFns } from "./ManualManage.vue?vue&type=template&id=161c2389"
import script from "./ManualManage.vue?vue&type=script&lang=js"
export * from "./ManualManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports